import React, {useCallback, useEffect, useState} from "react";

function Fomo({item}) {
  const quantity = item.quantity
  const sold = Math.floor(Math.random() * 10) + 1;
  const people = Math.floor(Math.random() * 10) + 1;
  const subject = people === 1? 'person' : 'people';
  const fomo = [`🔥 ${people} ${subject} watching this item right now!`,`🔥 ${people} ${subject} watching this item right now!`];
  // const fomo = [`🔥 ${sold} sold in the last 24 hours, just ${quantity}pcs left!`, `🔥 ${people} ${subject} watching this item right now!`];
  const [newFomo, setnewFomo ] = useState(`🔥 ${people} ${subject} watching this item right now!`)
  const shuffle = useCallback(() => {
    const index = Math.floor(Math.random() * fomo.length);
    setnewFomo(fomo[index]);
  }, []);
  useEffect(() => {
    const intervalID = setInterval(shuffle, 2000);
    return () => clearInterval(intervalID);
  }, [shuffle])

  return (
    <div style={{width: '100%', lineHeight:'26px'}}>
      <p style={{textAlign:'center', backgroundColor:'#FFEACB', paddingTop:'16px', paddingBottom:'16px', fontWeight:600, fontSize:'14px', lineHeight:'21px'}}>{newFomo}</p>
    </div>
  )
}
export default Fomo
